import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import { Button } from "../../components/ui/button";
import Workspace from "../../components/workspace";
import { ServiceReportForm } from "./service-report-form";
import { ServiceReportListContainer } from "./service-report-list-container";

const ServiceReportPage = () => {
   const [searchQuery, setSearchQuery] = useState("");
   const [page, setPage] = useState(1);
   const formModal = useDisclosure();
   return (
      <>
         <ServiceReportForm modal={formModal} />
         <Workspace.TopBar heading="Service Report Management" />
         <Workspace.WorkspaceActions>
            <Button variant="primary" onClick={formModal.onOpen}>
               <span className="inline-flex items-center gap-2">
                  <BiPlus className=" text-lg" />
                  Create new report
               </span>
            </Button>
         </Workspace.WorkspaceActions>
         <Workspace.ComponentWrapper>
            <Workspace.ListContainerHeader>
               <Workspace.HeaderPadding>
                  <Workspace.ListTitleWrapper>
                     <Workspace.ListTitle>Service Reports</Workspace.ListTitle>
                     <Workspace.HeaderSearchWrapper>
                        <Workspace.HeaderSearchForm
                           onSubmit={(e) => {
                              setPage(1);
                              setSearchQuery(e);
                           }}
                        />
                     </Workspace.HeaderSearchWrapper>
                  </Workspace.ListTitleWrapper>
               </Workspace.HeaderPadding>
            </Workspace.ListContainerHeader>
            <ServiceReportListContainer search={searchQuery} page={page} setPage={setPage} />
         </Workspace.ComponentWrapper>
      </>
   );
};

export default ServiceReportPage;
